import { HomeKpis } from '../components/HomeKpis';
import { UpcomingPrograms } from '../components/UpcomingPrograms';

export const Home = () => {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-xl font-semibold text-gray-900">Home</h1>
      <HomeKpis />
      <UpcomingPrograms />
    </div>
  );
};
